export const CUSTOM_ICON_PREFIX = 'icon';
